import { SearchOutlined } from '@ant-design/icons';
import Popup from '@root/core/components/Popup';
import useDebounce from '@root/core/hooks/useDebounce';
import ImportServices from '@root/modules/Sellers/Import/services/import';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import AttachDown from '@root/modules/Warehouse/Inquiry/components/attachment/AttachDown';
import Comment from '@root/modules/Warehouse/Inquiry/components/comment';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import CheckPoint from '@root/modules/Warehouse/Inquiry/components/shipping/CheckPoint';
import ShipmentMethod from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethod';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { AutoComplete, Form, message } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ImportBox from '../../Import/components/ImportBox';
import Recipient from '../components/Recipient/Recipient';
import MypageServices from '@root/modules/Sellers/Mypage/services/mypage';

interface Props {
  tab?: string;
}

const CancelProduct = ({ tab }: Props) => {
  const [openReject, setOpenReject] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [value, setValue] = useState('');
  const debounce = useDebounce(value, 1000);
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [detailProduct, setDetailProduct] = useState([] as any);
  const [dataShip, setDataShip] = useState([] as any);
  const [dataComment, setDataComment] = useState([] as any);
  const [myInfo, setMyInfo] = useState({} as any);
  const [destroy, setDestroy] = useState('');
  const history = useHistory();
  const [body, setBody] = useState<any>();
  const [lstProduct, setLstProduct] = useState<any[]>([]);

  const onSearch = async (searchText: string) => {
    const listId = await ReturnServices.searchQuotation(searchText);
    if (listId) {
      setOptions(
        listId.length == 0
          ? []
          : listId.data.map((value: any) => {
              return { value: value.id };
            })
      );
    }
  };

  useEffect(() => {
    onSearch(value);
  }, [debounce]);

  const onSelect = async (data: string) => {
    setLstProduct([]);
    const importDetail = await ImportServices.getListImportDetail(data);
    setDataComment(importDetail.data);
    setDataShip(importDetail.data.quotation);
    const list: any[] = [];
    const arrData: any[] = importDetail.data.quotation.products;
    arrData.forEach((item: any, index: number) => {
      list.push({
        productId: item.id,
        productName: item.productName,
        width: item.width,
        height: item.height,
        length: item.length,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods === true ? 'Yes' : 'No',
        lotProduct: item.lotProduct,
        deliveredDate: formatDateTime(item.historyProductInboundInventory?.deliveredDt),
        location: item.historyProductInboundInventory?.location,
        est: item.historyProductInboundInventory?.estimatedQuantity,
        deliveredQuantity: item.historyProductInboundInventory?.deliveredQuantity,
        availableQuantity: item.historyProductInboundInventory?.availableQuantity,
        unAvailableQuantity: item.historyProductInboundInventory?.unAvailableQuantity,
        inspectionResult: item.historyProductInboundInventory?.inspectionResult,
        returnQuantity: item?.returnQuantity,
        image: item?.image?.url
      });
    });
    setDetailProduct(list);
  };

  const onChange = (data: string) => {
    setValue(data);
    if (!data) {
      setDetailProduct([]);
      setDataShip([]);
      setDataComment([]);
      setLstProduct([]);
    }
  };

  const childRef: any = useRef();

  const [counter, setCounter] = useState(0);
  let idArr = [...lstProduct];
  const onChangeCheck = (e: CheckboxChangeEvent) => {
    const oldProduct = lstProduct;
    const product = e.target.value;
    if (e.target.checked) {
      setCounter(counter + 1);
      oldProduct.push(product);
      setLstProduct(oldProduct);
    } else {
      setCounter(counter - 1);
      const index = oldProduct.findIndex(
        (x) => x.productId === product.productId
      );
      oldProduct.splice(index, 1);
      setLstProduct(oldProduct);
    }
  };
  useEffect(() => {
    setLstProduct(lstProduct);
  }, [lstProduct]);

  const getMyInfo = async () => {
    const { data } = await MypageServices.getSellerID();
    setMyInfo({
      firstName: data.firstName,
      lastName: data.lastName,
      id: data.id
    });
  };

  useEffect(() => {
    getMyInfo();
  }, []);

  /*---------------OK reject-------------------*/
  const handleOKRejectWare = async () => {
    const createCmt = await ReturnServices.createCommenReturn(body);
    if (createCmt.massage === 'success') {
      message.success('Add comment success!');
      if (body.processType === 'return') {
        history.push('/admin/seller/return');
      } else {
        history.push('/admin/seller/return-disposal');
      }
    }
    setOpenReject(false);
  };

  /*---------------OK approve-------------------*/

  const handleOKApproveWare = async () => {
    const createCmt = await ReturnServices.createCommenReturn(body);
    if (createCmt.massage === 'success') {
      message.success('Add comment success!');
      if (body.processType === 'return') {
        history.push('/admin/seller/return');
      } else {
        history.push('/admin/seller/return-disposal');
      }
    }
    setOpenApprove(false);
  };

  useEffect(() => {
    let locat: any = history.location.state;
    if (!!locat && !!locat.idImport) {
      setValue(locat?.idImport);
      onSelect(locat?.idImport);
      setOptions([]);
    }
  }, [history]);

  return (
    <div className="requestInbound">
      <p>Inbound Number</p>
      <Form.Item className="searchOrder" name="orderNumber">
        <div className="searchOrder-box">
          <AutoComplete
            value={value}
            onChange={onChange}
            options={options}
            onSelect={onSelect}
          ></AutoComplete>
        </div>
        <SearchOutlined style={{ right: '52%' }} />
      </Form.Item>
      <div className="displayName">
        <p>{`${dataShip.seller?.firstName || (myInfo?.firstName ?? '') } ${
          dataShip.seller?.lastName || (myInfo?.lastName ?? '')
        }`}</p>
        <p
          style={{
            marginLeft: '10px',
            color: 'rgb(116, 114, 116)'
          }}
        >
          {dataShip.seller?.id ?? myInfo?.id}
        </p>
      </div>
      <div style={{ padding: '10px 0px' }}>
        {detailProduct.length !== 0 ? (
          <>
            {detailProduct.map((item: any, index: number) => {
              return (
                <DetailsPro
                  key={index}
                  onChangeCheck={onChangeCheck}
                  item={item}
                  id={item.productId}
                  haveCheck
                  productName={item.productName}
                  width={item.width}
                  height={item.height}
                  length={item.length}
                  demensionUnit={item.demensionUnit}
                  weight={item.weight}
                  weightUnit={item.weightUnit}
                  estimateQuantity={item.estimateQuantity}
                  averageMonthSale={item.averageMonthSale}
                  sku={item.sku}
                  eanUpc={item.eanUpc}
                  asin={item.asin}
                  packedMethod={item.packedMethod}
                  storageMethod={item.storageMethod}
                  dangerousGoods={item.dangerousGoods}
                  lotProduct={item.lotProduct}
                  img={item.image}
                />
              );
            })}
          </>
        ) : (
          <>
            <DetailsPro />
          </>
        )}
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <ShipmentMethod
          shipmentMethod={dataShip.shipmentMethod}
          shipmenDetail={dataShip.shipmentDetail}
        />
        <ShippingPlant
          shippingPlanEtd={dataShip.shippingPlanEtd}
          shippingPlanEta={dataShip.shippingPlanEta}
          onChange={() => {}}
        />
        <CheckPoint checkPoint={dataShip.checkPoint} />
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
        <AttachDown
          label="Customer’s attachments"
          documents={dataComment.attachments}
        />
        <Comment
          title="Comment from Customer :"
          date={formatDateTime(dataComment.WarehouseCommentDate)}
          content={dataComment.warehouseComment}
          btnText=""
        />
      </div>
      <ImportBox flag={true} listReturn={detailProduct} />
      <Recipient
        entityId={value}
        isCancelBtn={true}
        setOpenReject={setOpenReject}
        setDestroy={setDestroy}
        idArr={idArr}
        nothaveBtn
        canEdit
        ref={childRef}
        listCheckProduct={lstProduct}
        setOpenApprove={setOpenApprove}
        getBody={setBody}
        tab={tab}
        RequestTitle='반환요청'
      />

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openReject}
        textCancel="취소"
        textOk="확인"
        title="반송 요청 하시겠습니까?"
        action_oke={handleOKRejectWare}
        action_cancel={() => {
          setOpenReject(false);
          // history.push('/admin/seller/return');
        }}
      />
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openApprove}
        textCancel="취소"
        textOk="확인"
        title="폐기 요청 하시겠습니까?"
        action_oke={handleOKApproveWare}
        action_cancel={() => {
          setOpenApprove(false);
          // history.push('/admin/seller/return-disposal');
        }}
      />
    </div>
  );
};

export default CancelProduct;
